/**
 * Empty-state placeholder (PHASE1 §7.4): an icon, a German headline, optional
 * description and a call-to-action for zero-data views.
 */
import type { ComponentType, ReactNode } from 'react';
import { Inbox, type LucideProps } from 'lucide-react';

export interface EmptyStateProps {
  icon?: ComponentType<LucideProps>;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon: Icon = Inbox, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <Icon className="h-12 w-12 text-slate-300 dark:text-slate-600" aria-hidden />
      <div className="space-y-1">
        <h3 className="text-base font-semibold text-slate-900 dark:text-slate-100">{title}</h3>
        {description ? (
          <p className="text-sm text-slate-400 dark:text-slate-500">{description}</p>
        ) : null}
      </div>
      {action ? <div className="mt-3">{action}</div> : null}
    </div>
  );
}
